/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-props-no-spreading */
import * as React from "react";
import { Tabs, Tab, Box } from "@mui/material";
import { useEditorContext } from "features/editor/context/editor";
import { History } from "features/editor/components/panels/History";
import { SimilarTranslation } from "features/editor/components/panels/SimilarTranslation";
import { Validation } from "features/editor/components/panels/Validation";
import { Original } from "features/editor/components/panels/Original";
import { Info } from "features/editor/components/panels/Info";
import type { PanelType } from "features/editor/types/panels";

interface IPanel {
  children?: React.ReactNode;
  isActive: boolean;
}

const Panel = (props: IPanel) => {
  const { children, isActive } = props;

  return (
    <Box hidden={!isActive} style={{ flex: 1, overflow: "auto", position: "relative", scrollbarGutter: "stable" }}>
      {isActive && <Box sx={{ p: 3, position: "relative" }}>{children}</Box>}
    </Box>
  );
};

export type ITabs = [PanelType, any][];

export const PanelsTabs = () => {
  const { activeItemIndex, activePanel, setActivePanel } = useEditorContext();

  const tabs: ITabs = [
    ["History", <History />],
    ["Similar translations", <SimilarTranslation />],
    ["Validation", <Validation />],
    ["Info", <Info />],
    ["Original", <Original />],
  ];

  const handleChange = (event: React.SyntheticEvent, value: PanelType) => {
    setActivePanel(value);
  };

  return (
    <Box sx={{ flex: 1, display: "flex", flexDirection: "column", width: "100%", height: "calc(100% - 15px)" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs value={activePanel} onChange={handleChange}>
          {tabs.map((tab, index) => (
            <Tab
              label={tab[0]}
              value={tab[0]}
              id={`simple-tab-${index}`}
              aria-controls={`simple-tabpanel-${index}`}
              key={index}
            />
          ))}
        </Tabs>
      </Box>
      {activeItemIndex === undefined ? (
        <Box sx={{ p: 5, textAlign: "center" }}>Click on Item to get data.</Box>
      ) : (
        tabs.map((tab, index) => (
          <Panel isActive={activePanel === tab[0]} key={index}>
            {tab[1]}
          </Panel>
        ))
      )}
    </Box>
  );
};
